 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"FixedInvitation~FxhDown~ScoreIntroduce":"FixedInvitation~FxhDown~ScoreIntroduce","FxhDown":"FxhDown","FixedInvitation~Notice~ProAd1~ProAd2~ProAd3~ProAd4~ScoreIntroduce~TeamPk-live~TeamPk-member~download":"FixedInvitation~Notice~ProAd1~ProAd2~ProAd3~ProAd4~ScoreIntroduce~TeamPk-live~TeamPk-member~download","FixedInvitation":"FixedInvitation","ScoreIntroduce":"ScoreIntroduce","Notice":"Notice","ProAd1":"ProAd1","ProAd2":"ProAd2","ProAd3":"ProAd3","ProAd4":"ProAd4","TeamPk-live":"TeamPk-live","TeamPk-member":"TeamPk-member","download":"download","ProAd":"ProAd","Protocol":"Protocol","TeamPk":"TeamPk","TeamPk-result":"TeamPk-result","TeamPk-rules":"TeamPk-rules","TestDownload":"TestDownload","invitation":"invitation","turntable":"turntable"}[chunkId]||chunkId) + "." + {"FixedInvitation~FxhDown~ScoreIntroduce":"79dbedc7","FxhDown":"79a9793d","FixedInvitation~Notice~ProAd1~ProAd2~ProAd3~ProAd4~ScoreIntroduce~TeamPk-live~TeamPk-member~download":"f778207f","FixedInvitation":"63437c02","ScoreIntroduce":"0c7b5c16","Notice":"fdd0570c","ProAd1":"7ed4e13d","ProAd2":"7b3243b1","ProAd3":"4d71e467","ProAd4":"139e2006","TeamPk-live":"2013563b","TeamPk-member":"ac5d95ea","download":"4dfb9367","ProAd":"2a40e67a","Protocol":"870c5589","TeamPk":"05f2cf9e","TeamPk-result":"b2288b83","TeamPk-rules":"cb95cfe3","TestDownload":"3fefe571","chunk-c8104342":"e40f247b","invitation":"d4e63a0e","turntable":"219a1b0c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"FxhDown":1,"FixedInvitation~Notice~ProAd1~ProAd2~ProAd3~ProAd4~ScoreIntroduce~TeamPk-live~TeamPk-member~download":1,"FixedInvitation":1,"ScoreIntroduce":1,"Notice":1,"ProAd1":1,"ProAd2":1,"ProAd3":1,"ProAd4":1,"TeamPk-live":1,"TeamPk-member":1,"download":1,"Protocol":1,"TeamPk":1,"TeamPk-result":1,"TeamPk-rules":1,"TestDownload":1,"chunk-c8104342":1,"invitation":1,"turntable":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"FixedInvitation~FxhDown~ScoreIntroduce":"FixedInvitation~FxhDown~ScoreIntroduce","FxhDown":"FxhDown","FixedInvitation~Notice~ProAd1~ProAd2~ProAd3~ProAd4~ScoreIntroduce~TeamPk-live~TeamPk-member~download":"FixedInvitation~Notice~ProAd1~ProAd2~ProAd3~ProAd4~ScoreIntroduce~TeamPk-live~TeamPk-member~download","FixedInvitation":"FixedInvitation","ScoreIntroduce":"ScoreIntroduce","Notice":"Notice","ProAd1":"ProAd1","ProAd2":"ProAd2","ProAd3":"ProAd3","ProAd4":"ProAd4","TeamPk-live":"TeamPk-live","TeamPk-member":"TeamPk-member","download":"download","ProAd":"ProAd","Protocol":"Protocol","TeamPk":"TeamPk","TeamPk-result":"TeamPk-result","TeamPk-rules":"TeamPk-rules","TestDownload":"TestDownload","invitation":"invitation","turntable":"turntable"}[chunkId]||chunkId) + "." + {"FixedInvitation~FxhDown~ScoreIntroduce":"31d6cfe0","FxhDown":"088fe92d","FixedInvitation~Notice~ProAd1~ProAd2~ProAd3~ProAd4~ScoreIntroduce~TeamPk-live~TeamPk-member~download":"1edd7712","FixedInvitation":"5fa49547","ScoreIntroduce":"aec94b46","Notice":"17d0ddc6","ProAd1":"ebc2e959","ProAd2":"e2122d3e","ProAd3":"48b7e159","ProAd4":"1e83477c","TeamPk-live":"092b1c2a","TeamPk-member":"73797045","download":"ea594180","ProAd":"31d6cfe0","Protocol":"6e4b6d7a","TeamPk":"d0dbc51d","TeamPk-result":"34b553a7","TeamPk-rules":"934cbc0d","TestDownload":"8e9b9c48","chunk-c8104342":"91736fa2","invitation":"3f5cc968","turntable":"d2b0b917"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
